import React, { useState, useRef } from 'react';
import {
  HomefieldIconChevronDown,
  HomefieldIconChevronRight,
  HomefieldIconChevronUp,
} from '@dsg-tech/homefield-react-icons';
import { ActionText, TextLink } from '@dsg-tech/homefield-react';
import { storeIdentifierNameSelector } from 'store/selectors/commonSelector';
import { useAppSelector } from 'store/store';
import useOutsideClick from './useOutsideClick.jsx';
import './AOSOffers.scss';

interface OfferProps {
  currentOffers: {
    headline: string;
    offers: Array<{ title: string; link?: string }>;
  };
}

const AOSOffers = (props: OfferProps) => {
  const { currentOffers } = props;
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const storeIdentifierName = useAppSelector(storeIdentifierNameSelector);

  // for these stores, the background-color is light and requires dark text
  // to provide suitable contrast. Other stores have darker backgrounds and
  // require inverted text
  const hasDefaultFontColor = storeIdentifierName === 'pl';

  useOutsideClick(ref, () => {
    setOpen(false);
  });

  const handleToggleOffers = () => {
    setOpen(!open);
  };

  if (!currentOffers) {
    return null;
  }
  const chevronIcon = open ? <HomefieldIconChevronUp /> : <HomefieldIconChevronDown />;

  return (
    <div
      className="current-offers hmf-position-relative hmf-p-xxs hmf-body-s hmf-m-0 hmf-p-0"
      ref={ref}>
      <ActionText
        variant={hasDefaultFontColor ? 'group' : 'group-inverse'}
        size="small"
        onClick={handleToggleOffers}
        className="current-offers-headline">
        <span className="action-text-content hmf-body-s">
          {currentOffers.headline}
          {chevronIcon}
        </span>
      </ActionText>
      <ul
        className={`current-offers-list hmf-position-absolute hmf-body-l hmf-p-0 hmf-mt-xxxs ${
          !open && `hidden`
        }`}>
        {currentOffers.offers &&
          currentOffers.offers.length !== 0 &&
          currentOffers.offers.map((offer: { title: string; link?: string }) => {
            if (offer.link) {
              return (
                <li key={offer.title} className="hmf-py-xs hmf-px-xs">
                  <span>
                    <TextLink href={offer.link} variant="group" size="small">
                      {offer.title}
                    </TextLink>
                    <HomefieldIconChevronRight />
                  </span>
                </li>
              );
            }
            return (
              <li key={offer.title} className="hmf-body-s hmf-py-xs hmf-px-xs">
                <span>{offer.title}</span>
              </li>
            );
          })}
      </ul>
    </div>
  );
};

export default AOSOffers;
